import { Card } from '@/components/ui/card';
import type { JournalCardResponsePayload } from '@domain/journal';

export type AcceptedCardsListProps = {
  cards: JournalCardResponsePayload[];
};

export default function AcceptedCardsList({ cards }: AcceptedCardsListProps) {
  if (!cards.length) {
    return null;
  }

  return (
    <Card className="p-4 space-y-2">
      <h3 className="text-sm font-semibold text-muted-foreground">Hai detto di sì a</h3>
      <ul className="space-y-2 text-sm">
        {cards.map((response) => (
          <li key={response.id} className="border rounded-md p-3 bg-muted/30">
            <p className="font-medium">{response.card?.text}</p>
            <p className="text-xs text-muted-foreground mt-1">
              {(response.card?.category || 'generale').charAt(0).toUpperCase() +
                (response.card?.category || 'generale').slice(1)}
            </p>
          </li>
        ))}
      </ul>
    </Card>
  );
}
